export default __webpack_public_path__ + "static/media/onlyfans.d17e7c64.png";